import { FC } from 'react'
import { Select, SelectItem, SelectSection } from '@nextui-org/react'
import type { Group } from '@/types/domain'

interface GroupDropdownProps {
  rowIndex: number
  selectedGroupId: string | null
  groups: Group[]
  onChange: (rowIndex: number, groupId: string | null, groupName: string | null) => void
  onCreateNew: (rowIndex: number) => void
}

const CREATE_NEW_KEY = '__create_new__'
export const UNGROUPED_KEY = '$ungrouped'

export const GroupDropdown: FC<GroupDropdownProps> = ({
  rowIndex,
  selectedGroupId,
  groups,
  onChange,
  onCreateNew,
}) => {
  const handleSelectionChange = (keys: any) => {
    const selected = typeof keys === 'string' ? keys : Array.from(keys)[0] as string
    if (!selected) return

    if (selected === CREATE_NEW_KEY) {
      onCreateNew(rowIndex)
      return
    }

    if (selected === UNGROUPED_KEY) {
      onChange(rowIndex, UNGROUPED_KEY, 'Ungrouped')
      return
    }

    const group = groups.find((g) => g.id === selected)
    if (group) {
      onChange(rowIndex, group.id, group.name)
    }
  }

  return (
    <Select
      aria-label="Select group"
      size="sm"
      variant="flat"
      placeholder="Select Group"
      className="min-w-[180px]"
      classNames={{
        trigger: 'h-8 min-h-8 bg-tdplbisque shadow-none p-0 px-2',
        value: 'text-small text-center',
        innerWrapper: 'p-0',
      }}
      selectedKeys={selectedGroupId ? [selectedGroupId] : []}
      onSelectionChange={handleSelectionChange}
      data-testid={`group-dropdown-${rowIndex}`}
    >
      <SelectSection showDivider items={[{ id: UNGROUPED_KEY, name: 'Ungrouped' }, ...groups]}>
        {(item) => (
          <SelectItem key={item.id} textValue={item.name}>
            {item.id === UNGROUPED_KEY
              ? <span className="text-black">{item.name}</span>
              : item.name}
          </SelectItem>
        )}
      </SelectSection>
      <SelectSection>
        <SelectItem key={CREATE_NEW_KEY} textValue="+ Create New Group">
          <span className="text-tdplplum font-semibold">+ Create New Group</span>
        </SelectItem>
      </SelectSection>
    </Select>
  )
}
